const IMG_ICONS = {
  kick: '/icons3d/kick.png',
  telegram: '/icons3d/telegram.png',
  instagram: '/icons3d/instagram.png',
  youtube: '/icons3d/youtube.png',
};

const SocialIcon = ({ kind, className = 'w-5 h-5' }) => {
  const src = IMG_ICONS[kind];
  if (src) {
    return <img src={src} alt={kind} className={className} style={{ objectFit: 'contain' }} />;
  }
  return null;
};

export default SocialIcon;
